// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .text-end[data-v-2609190e]{text-align:right}[dir=rtl] .text-end[data-v-2609190e]{text-align:left}", ""]);
// Exports
module.exports = exports;
